import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
// import { selectDragActiveId, selectNow, setUpdateActionStamp } from "../../../AppSlice";
// import { PlayoutScheduler } from "../../../helpers/playoutScheduler";
// import { emptyCalendarItem } from "../../panels/Calendar/Calendar.model";
import styles from './Calendar.module.scss';
// import { conlog } from "../../../helper";
import { emptyTimelineItem, IDrawEvent, ITimelineItem } from "./Timeline.model";
// import { PanelTypes } from "../../panels/Panels";
// import CalendarItem from "../../panels/Calendar/CalendarItem";
// import { dragItem, duplicateEvent, selectCalendarItems, selectDragItemId, selectDrawEvent, selectDrawMode, selectDuplicateMode, selectEditMode, selecteditedPopoutItems, selectNowPosition, selectSelectedCalItemId, selectSelectedChannel, selectShowDetailsItemId, selectZoom, selectZoomFactor, setCreateFromDrawEvent, setDragCalItemId, setDrawEvent, setDrawMode, setDuplicateMode, setNowPosition, setSelectedCalItemId, setShowDetailsItemId } from "../../panels/Calendar/CalendarSlice";
// import { v4 as uuidv4 } from 'uuid';
// import { Box, colors } from "@mui/material";
// import { selectPlaylists } from "../Playlists/PlaylistSlice";
// import { permissions, userCan } from "../../../helpers/permissions";
// import CalendarTimesRow from "./CalendarTimesRow";
// import { conlog } from "../../../helper";
// import { conlog } from "../../../helper";

export default function DayRow({ 
    day, 
    index, 
    panelName,
    rowHeight,
    selecedChannel ,
    contentWidth,
    zoom,
    drawMode,
    TimelineItemComponent,
    items,
    editMode,
    setDrawMode,
    drawEvent,
    setDrawEvent,
    onClickFreespace,
    dragItemdId,
    onDragItem,
    setDragItemId,
    onCreateDrawEvent,
    selectedDrawChannelIds = [],
}: { 
    day: any; 
    panelName: "recording";
    items: ITimelineItem[];
    selecedChannel: string;
    index: number; 
    rowHeight: number;
    contentWidth: number;
    zoom: number[];
    editMode: boolean;
    TimelineItemComponent: React.FC<any>;
    drawMode: boolean;
    setDrawMode: (val: boolean) => void;
    drawEvent: IDrawEvent;
    dragItemdId: string;
    onDragItem: (item: { id: string, start: string}) => void;
    onCreateDrawEvent: (item: IDrawEvent) => void;
    setDrawEvent: (val: IDrawEvent) => void;
    setDragItemId: (id: string) => void;
    onClickFreespace?: (e: React.MouseEvent<HTMLDivElement>) => void;
    selectedDrawChannelIds?: string[];
}) {

    const dispatch = useAppDispatch()
    // const items = useAppSelector(items)
    // const editedItems = useAppSelector(selecteditedPopoutItems)
    // const editMode = useAppSelector(selectEditMode)
    // const zoom = useAppSelector(selectZoom)
    // const now = useAppSelector(selectNow)
    // const selecedCalItemId = useAppSelector(selectSelectedCalItemId)
    // const selecedChannel = useAppSelector(selectSelectedChannel)
    // const dragCalItemId = useAppSelector(selectDragItemId)
    // const popoutEditItems = useAppSelector(selecteditedPopoutItems)
    // const showDetailsItemId = useAppSelector(selectShowDetailsItemId)
    // // const playlists = useAppSelector(selectPlaylists)
    // // const dragActiveId = useAppSelector(selectDragActiveId)
    const [nowPosition, setNowPosition] = useState(0)
    const contentRef = useRef(null)
    // const [drawEvent, setDrawEvent] = useState<IDrawEvent>(emptyDrawEvent)
    // // const zoomFactor = useAppSelector(selectZoomFactor)
    // const newEvent = popoutEditItems["new_0"] //.find(item => item.id === "new_0")
    // const drawMode = useAppSelector(selectDrawMode)
    // const drawEvent = useAppSelector(selectDrawEvent)
    // const duplicateMode = useAppSelector(selectDuplicateMode)
    // const nowPosition = useAppSelector(selectNowPosition)

    const handleDown = (id) => {
        window['clickInItem'] = true
        // if (duplicateMode && id !== "new_0") {
        //     dispatch(duplicateEvent(id))
        //     if (showDetailsItemId) dispatch(setShowDetailsItemId("new_0"))
        //     dispatch(setSelectedCalItemId("new_0"))
        //     dispatch(setDragCalItemId("new_0"))
        // } else {
            // if (showDetailsItemId) dispatch(setShowDetailsItemId(id))
            // dispatch(setSelectedCalItemId(id))
            let itemStatus = items.find(item => item.id === id)?.status
            if (itemStatus !== "2" && itemStatus !== "3" && editMode){ // && userCan("scheduler", permissions.scheduler.can_edit_existing_schedule.id)) {
                setDragItemId(id)
            }
        // }
        // dispatch(setDuplicateMode(false))
    }

    // const calcStartPerc = () => {
    //     if (moment.utc(now).startOf("day").unix() === moment.utc(day).startOf("day").unix()) {
    //         let c = (moment.utc(moment.utc(now).local().format("YYYY-MM-DD HH:mm:ss")).unix() - moment.utc(day).startOf("day").unix()) / (60 * 60 * 24) * 100
    //         if (c > 100) return null
    //         return c
    //     }
    //     return null
    // }

    // useEffect(() => {
    //     let pos = calcStartPerc()
    //     if (pos) {
    //         setNowPosition(pos)
    //     }
    // }, [now])

    const rect = contentRef.current?.getBoundingClientRect()

    const getPositionTime = e => {
        let perc = (e.clientX - rect.x) / rect.width * 100
        let start = moment.utc(day).unix() + (60 * 60 * 24 * perc / 100) - 1000
        start = moment(moment.unix(start).utc().format("YYYY-MM-DD HH:mm:ss")).unix()
        return start
    }

    const onRowMouseDown = e => {
        if (drawMode) {
            let currect = getPositionTime(e)
            if (currect) {
                currect = getSanpRange(currect)
                const nextChannelIds = selectedDrawChannelIds.length > 0
                    ? selectedDrawChannelIds
                    : [selecedChannel];
                setDrawEvent({
                    ...drawEvent,
                    startTime: moment.unix(currect).toISOString(),
                    endTime: moment.unix(currect).toISOString(),
                    channel: selecedChannel,
                    channelIds: nextChannelIds,
                })
            }
        }
    }

    const getSanpRange = currect => {
        let sn = drawEvent?.snapValue * 60 * 3
        return Math.ceil(currect / sn) * sn
    }

    const onRowMouseUp = e => {
        if (drawMode) {
            let currect = getPositionTime(e)
            if (currect) {
                currect = getSanpRange(currect)
                let newItem = { ...drawEvent, endTime: moment.unix(currect).toISOString() }
                setDrawEvent(newItem)
                onCreateDrawEvent(newItem)
                // dispatch(setCreateFromDrawEvent())
            }
            setDrawMode(false)
            // dispatch(setUpdateActionStamp())
        }
    }

    const handleMove = (e) => {
        // conlog('movee', e.clientX - rect.x, rect.width, drawEvent);

        if (dragItemdId && e.movementX) {
            let currect = getPositionTime(e)
            if (currect) {
                onDragItem({ id: dragItemdId, start: moment.unix(currect).toISOString() })
                // dispatch(dragItem({ id: selecedCalItemId, start: moment.unix(currect).toISOString(), channel: selecedChannel }))
            }
        }

        if (drawMode && drawEvent?.startTime) {
            let currect = getPositionTime(e)
            if (currect) {
                currect = getSanpRange(currect)
                setDrawEvent({ ...drawEvent, endTime: moment.unix(currect).toISOString() })
            }
        }

    }

    {/* background: moment.utc(day).date() === moment.utc(now).date() ? 'rgba(220, 200, 187, 0.5)' : colors.lime */ }
    return (
        <div className={styles.dayRow} onMouseMove={handleMove} style={{ height: rowHeight }}>
            <div className={styles.dayContent} ref={contentRef} style={{ width: `${contentWidth}px`, borderBottom: "1px dashed #888" }}>
                {/* {(index + 1) % 8 === 0 ? <CalendarTimesRow /> : null} */}
                <div className={styles.tableDiv} >
                    <table style={{ height: rowHeight}}>
                        <tr >
                            {Array.from(Array(24)).map((item, i) => <td key={'day' + i} style={{ width: `${100 / 24}%` }} ></td>)}
                        </tr>
                    </table>
                </div>
                <div className={styles.dayItems} style={{ height: rowHeight }} onMouseDown={onRowMouseDown} onMouseUp={onRowMouseUp} onDoubleClick={onClickFreespace}>
                    {items?.filter(item => item?.channel === selecedChannel)?.map((item, i) => <TimelineItemComponent rowHeight={rowHeight} key={'timelineitem' + item.id + i} item={item} day={day} hoursBeforeDay={0} hoursAfterDay={0} onMouseDown={handleDown} />)}
                    {(drawEvent?.channelIds?.includes(selecedChannel) || drawEvent?.channel === selecedChannel) ? <TimelineItemComponent key={'timelineitem_drawevent' + panelName + selecedChannel} rowHeight={rowHeight} item={{ ...emptyTimelineItem, start: drawEvent.startTime, channel: selecedChannel, length: moment(drawEvent.endTime).unix() - moment(drawEvent.startTime).unix() }} day={day} hoursBeforeDay={0} hoursAfterDay={0} onMouseDown={handleDown} /> : null} 
                    {/* {items.filter(item => item?.channel === selecedChannel).filter(item => !Object.keys(popoutEditItems).includes(item?.id)).map((item, i) => <CalendarItem rowHeight={rowHeight} key={'dayitem' + item.id + i} item={item} day={day} onMouseDown={handleDown} />)}
                    {items.filter(item => item?.backupChannel === selecedChannel).filter(item => !Object.keys(popoutEditItems).includes(item?.id)).map((item, i) => <CalendarItem rowHeight={rowHeight} key={'dayitem_backup' + item.id + i} isBackup={true} item={item} day={day} onMouseDown={handleDown} />)}
                    {Object.values(popoutEditItems).filter(item => item?.channel === selecedChannel).map((item, i) => <CalendarItem rowHeight={rowHeight} key={'dayitem_popout_' + item.id + i} item={item} day={day} onMouseDown={handleDown} isEdited={true} />)}
                    {Object.values(popoutEditItems).filter(item => item?.backupChannel === selecedChannel).map((item, i) => <CalendarItem rowHeight={rowHeight} key={'dayitem_backup_popout_' + item.id + i} item={item} day={day} onMouseDown={handleDown} isBackup={true} isEdited={true} />)}
                    {newEvent?.channel === selecedChannel ? <CalendarItem rowHeight={rowHeight} item={newEvent} day={day} onMouseDown={handleDown} /> : null}
                    {newEvent?.backupChannel === selecedChannel ? <CalendarItem rowHeight={rowHeight} item={newEvent} day={day} isBackup={true} onMouseDown={handleDown} /> : null}
                    */}
                </div>
                {/* {moment.utc(now).startOf("day").unix() === moment.utc(day).startOf("day").unix() && nowPosition ? <div style={{ width: '1px', height: rowHeight + 10, border: '1px solid red', top: '-5px', left: `${nowPosition}%`, zIndex: 150, position: 'absolute' }} /> : null} */}
            </div>
        </div>
    )
}
